import GatewayAxiosClient from '../GatewayAxiosClient';
import type { TrackingResponse, TrackingRequest, BulkTrackingRequest } from './types';
import { getToken } from '../../session';

export class TrackingService {
  public async bulkCarrierTrackingSearch(payload: TrackingRequest): Promise<TrackingResponse[]> {
    const { trackingIds, carrier, excludeEvents = false } = payload;
    const res = await GatewayAxiosClient.post(
      '/tracking-proxy/api/v1/tracking/bulkCarrierTrackingSearch',
      {
        excludeEvents,
        trackingSearchOverride: {
          ignorePartnerId: true,
        },
        trackingSearchRequests: trackingIds.map((carrierTrackingId) => ({
          carrierId: carrier,
          carrierTrackingId,
        })),
      },
      { headers: { authorization: `Bearer ${getToken()}` } },
    );
    return res.data.trackings;
  }
  public async getTrackingByShipiumTrackingId(shipiumTrackingId: string): Promise<TrackingResponse> {
    const res = await GatewayAxiosClient.get(
      `/tracking-proxy/api/v1/internal/tracking/${shipiumTrackingId}?excludeEvents=false`,
      { headers: { authorization: `Bearer ${getToken()}` } },
    );
    return res.data;
  }
  public async getTrackingByCarrierTrackingId(carrierTrackingId: string, carrierId: string): Promise<TrackingResponse> {
    const res = await GatewayAxiosClient.get(
      `/tracking-proxy/api/v1/internal/tracking/carrier/${carrierId}/${carrierTrackingId}?excludeEvents=false`,
      { headers: { authorization: `Bearer ${getToken()}` } },
    );
    return res.data;
  }

  public async bulkTrackingSearch(payload: BulkTrackingRequest): Promise<TrackingResponse[]> {
    const { shipiumTrackingIds, excludeEvents = false } = payload;
    const res = await GatewayAxiosClient.post('/tracking-proxy/api/v1/internal/tracking/bulkTrackingSearch', {
      excludeEvents,
      shipiumTrackingIds,
    });
    return res.data.trackings;
  }
}
